@let isDisabled = editService.loading() || editDataService.documentIsBlocked();
@let isTemplateMode = templateEditService.isTemplateMode();

<!-- Overlay full-screen durante a clonagem/movimentação (mesmo padrão da criação de documento) -->
@if (editService.cloningDocument()) {
    <ra-full-page-loading [message]="'document.edit.service.cloningDocument' | translate" />
}
@if (editService.movingDocument()) {
    <ra-full-page-loading [message]="'document.edit.service.movingDocument' | translate" />
}
@if (editService.correctingAllTexts()) {
    <ra-full-page-loading [message]="'document.edit.service.correctingAllTexts' | translate" />
}
@if (editService.fieldIaActionKey(); as fieldIaActionKey) {
    <ra-full-page-loading [message]="fieldIaActionKey | translate" />
}
@if (editService.fieldMediaActionKey(); as fieldMediaActionKey) {
    <ra-full-page-loading [message]="fieldMediaActionKey | translate" />
}

<!-- Left: voltar, toggle da sidebar e título -->
<div class="header-left">

    <!-- Voltar -->
    <ra-icon
        class="header-icon-button"
        icon="arrow-left"
        varColor="currentColor"
        [size]="20"
        [class.default-disabled]="editService.loading() || leaving()"
        [raEditTooltip]="{ text: ('document.edit.sessionsList.back' | translate), position: 'bottom' }"
        (click)="backPage()" />

    <!-- Document title -->
    @if (isEditingTitle())
    {
        <input
            #titleInput
            id="edit-doc-title-input"
            class="edit-doc-title-input"
            [value]="tempTitle()"
            (blur)="saveTitle()"
            (keydown)="onTitleKeyDown($event)"
            (input)="tempTitle.set($any($event.target).value)"
        />
    }
    @else
    {
        <div
            id="edit-doc-title-static"
            class="edit-doc-title"
            [class.default-disabled]="isDisabled"
            [raEditTooltip]="{ text: ('document.edit.header.clickToEditTitle' | translate), position: 'right' }"
            (click)="startEditingTitle()">
            <p>{{ editDataService.document()?.title }}</p>
        </div>
    }

    <!-- Modo modelo: o que está aberto é o rascunho de edição de um modelo, e o título
         acima é o do DOCUMENTO que o modelo gera. Sem esta etiqueta a tela é idêntica à
         de um documento comum. -->
    @if (isTemplateMode) {
        @let templateName = templateEditService.templateName();
        <div
            class="template-mode-chip"
            [raEditTooltip]="{
                text: templateName
                    ? ('document.edit.templateMode.hintNamed' | translate: { name: templateName })
                    : ('document.edit.templateMode.hint' | translate),
                position: 'bottom'
            }">
            <ra-icon icon="template" varColor="currentColor" [size]="16" />
            <p class="ra-label-s">{{ 'document.edit.templateMode.label' | translate }}</p>
        </div>
    }

    <!-- Cadeado: indica documento privado (qualquer tipo). Abre a visibilidade. -->
    @if (editDataService.document()?.private) {
        <ra-icon
            class="header-icon-button"
            icon="lock"
            varColor="contentSecondary"
            [size]="18"
            [raEditTooltip]="{ text: ('document.edit.header.visibility' | translate), position: 'bottom' }"
            (click)="showModalDocumentVisibility.set(true)"
        />
    }

    <!--
        Retorno de salvamento: só o "Salvo" depois de gravar (o "Salvando…" saiu em
        2026-09-25 a pedido do usuário: com o autosave a cada pausa da digitação ele
        piscava o tempo todo). Uma falha de rede continua avisando pelo toast de erro.
    -->
    @if (aiEditStore.stage() === 'applying') {
        <!-- Modo IA, estado 3: as alterações da IA estão sendo gravadas. -->
        <div class="save-state save-state--ai" role="status">
            <span class="save-state-spinner" aria-hidden="true"></span>
            <span>{{ 'document.edit.aiEdit.headerApplying' | translate }}</span>
        </div>
    } @else if (editDataService.justSaved()) {
        <div class="save-state save-state--saved" role="status">
            <ra-icon [icon]="'tick'" [size]="14" [varColor]="'currentColor'" />
            <span>{{ 'document.edit.sessionsList.documentSaved' | translate }}</span>
        </div>
    }
</div>

<!-- Actions -->
<div class="container-actions">

    <!-- Loading -->
    @if (editService.loading()) {
        <div class="container-loading">
            <ra-loading />
            <p>{{ (editService.loadingMessageKey() | translate) || ('document.edit.header.pleaseWait' | translate) }}</p>
        </div>
    } @else if (downloading()) {
        <div class="container-loading">
            <ra-loading />
            <p>{{ 'document.edit.header.downloadingPdf' | translate }}</p>
        </div>
    }

    <!-- Progresso do checklist (à esquerda da colaboração ao vivo): a etapa na
         trilha, com um ponto por seção; muitas seções viram o anel; concluído
         vira a pílula verde -->
    @if (isChecklistMode()) {
        @let checklistProgress = editDataService.document()?.sessions | checklistCompletion;
        @let steps = checklistSteps();
        <div
            class="checklist-pill"
            [class.complete]="steps.complete"
            [raEditTooltip]="{ text: ('document.edit.checklist.completedCount' | translate:{ done: checklistProgress.done, total: checklistProgress.total }), position: 'bottom' }">
            @if (steps.complete) {
                <ra-icon icon="tick" varColor="currentColor" [size]="16" />
                <span class="pill-text">{{ 'document.edit.checklist.stepsDone' | translate }}</span>
            }
            @else if (steps.total > 0 && steps.total <= 8) {
                <span class="pill-dots" aria-hidden="true">
                    @for (step of steps.steps; track step.sessionId) {
                        <span class="pill-dot" [class.done]="step.done" [class.current]="step.current"></span>
                    }
                </span>
                <span class="pill-text">{{ 'document.edit.checklist.step' | translate:{ current: steps.current?.num, total: steps.total } }}</span>
            }
            @else {
                <svg class="checklist-ring" viewBox="0 0 36 36" aria-hidden="true">
                    <circle class="ring-track" cx="18" cy="18" r="15" fill="none" stroke-width="5" />
                    <circle
                        class="ring-fill"
                        cx="18"
                        cy="18"
                        r="15"
                        fill="none"
                        stroke-width="5"
                        stroke-linecap="round"
                        transform="rotate(-90 18 18)"
                        stroke-dasharray="94.248"
                        [attr.stroke-dashoffset]="94.248 - (94.248 * checklistProgress.percent / 100)" />
                </svg>
                <span class="pill-text">
                    @if (steps.total > 0) {
                        {{ 'document.edit.checklist.step' | translate:{ current: steps.current?.num, total: steps.total } }}
                    }
                    @else {
                        {{ checklistProgress.percent }}%
                    }
                </span>
            }
        </div>
    }

    <!-- Limites de uso: quanto do plano já foi consumido (IA, PDF, armazenamento),
         com o detalhe e o saldo num popover. Atualiza ao vivo a cada gasto. -->
    <usage-limits-pill />

    <!-- Grupo: colaboração ao vivo (status + avatares) -->
    @if (!isTemplateMode) {
    <div class="live-chip">
        <span class="live-dot"></span>
        <p class="ra-label-s">{{ 'document.edit.header.live' | translate }}</p>

        @if (editDataService.document()?.onlineUsers && editDataService.document()?.onlineUsers.length > 0) {
            <ra-avatars-list
                [avatarSize]="26"
                [showTooltipName]="true"
                [users]="editDataService.document()?.onlineUsers"
            />
        }
    </div>

    <span class="action-divider"></span>
    }

    <!-- Grupo: ferramentas — só a IA fica exposta (diferencial do produto);
         as demais ferramentas vivem no menu ⋯ com rótulo. -->
    <div class="action-group tools">

        <!-- Corrigir todos os textos (IA) -->
        <ra-square-icon
            class="tool-ai"
            [size]="38"
            [icon]="'magicpen'"
            [disabled]="isDisabled"
            [raEditTooltip]="{ text: ('document.edit.header.correctAllTexts' | translate), position: 'bottom' }"
            (click)="!isDisabled ? editService.typoAllTextsIa() : null"
        />
    </div>

    <span class="action-divider"></span>

    <!-- Grupo: ações primárias -->
    <div class="action-group">

        <!-- Prévia do PDF (painel lateral, atualiza sozinha ao editar).
             O antigo "Visualizar" saiu daqui: abria o mesmo link público que agora é o
             item "Compartilhar link" do menu ⋮, ao lado do QR Code (que aponta para ele). -->
        <!-- Com o "Visualizar" fora, esta virou a ação primária do header: cheia quando
             fechada, contornada quando o painel está aberto (marca o estado). Em CONTRATO
             continua contornada, para não competir com "Assinaturas". -->
        @if (!editModeService.isAiMode()) {
            <div
                class="container-action-item"
                [class.primary]="
                    editDataService.document()?.type != DocumentTypeEnum.CONTRACT &&
                    !editDataService.pdfPreviewOpen()
                "
                [class.primary-outline]="
                    editDataService.document()?.type == DocumentTypeEnum.CONTRACT ||
                    editDataService.pdfPreviewOpen()
                "
                [raEditTooltip]="
                    editDataService.pdfPreviewBusy()
                        ? { text: ('document.edit.pdfPreview.recalculating' | translate), position: 'bottom' }
                        : null
                "
                (click)="editDataService.togglePdfPreviewOpen()">

                <!-- Recalculando: o spinner toma o lugar do ícone. A prévia repagina também
                     com o painel fechado (é ela que mantém os traços de quebra em dia), então
                     sem este sinal a espera não teria explicação nenhuma na tela. -->
                @if (editDataService.pdfPreviewBusy()) {
                    <span class="preview-spinner" aria-hidden="true"></span>
                } @else {
                    <ra-icon icon="document-normal" varColor="currentColor" [size]="18" />
                }

                <p class="ra-label-s">{{ 'document.edit.header.pdfPreview' | translate }}</p>
            </div>
        }

        <!-- Assinaturas -->
        @if (!isTemplateMode && editDataService.document()?.type == DocumentTypeEnum.CONTRACT) {
            <div
                class="container-action-item primary"
                [class.default-disabled]="editService.loading()"
                (click)="!editService.loading() ? showModalContractSigners.set(true) : null">
                <p class="ra-label-s">{{ 'document.edit.header.signatures' | translate }}</p>
            </div>
        }

        <!-- Mais ações (overflow): ações destrutivas isoladas do fluxo principal -->
        <div
            class="more-menu-wrapper"
            clickOutside
            [clickOutsideEnabled]="showMoreMenu()"
            (clickOutside)="showMoreMenu.set(false)">

            <!-- O ⋯ fica sempre habilitado: dá acesso ao histórico (read-only)
                 mesmo durante carregamentos; cada item guarda o próprio estado. -->
            <ra-square-icon
                [size]="38"
                [icon]="'more-vertical'"
                [raEditTooltip]="{ text: ('document.edit.header.moreActions' | translate), position: 'bottom' }"
                (click)="showMoreMenu.set(!showMoreMenu())"
            />

            @if (showMoreMenu()) {
                <div class="more-menu">
                    <!-- Configuração do documento -->
                    <button
                        type="button"
                        class="more-menu-item"
                        [disabled]="isDisabled"
                        (click)="showMoreMenu.set(false); isModalDocumentConfigVisible.set(true)">
                        <ra-icon icon="setting" varColor="currentColor" [size]="18" />
                        <span class="ra-label-s">{{ 'document.edit.header.documentSettings' | translate }}</span>
                    </button>

                    <!-- Transformar em / desativar checklist -->
                    <button
                        type="button"
                        class="more-menu-item"
                        (click)="showMoreMenu.set(false); onToggleChecklist()">
                        <ra-icon icon="tick" varColor="currentColor" [size]="18" />
                        <span class="ra-label-s">
                            @if (isChecklistMode()) {
                                {{ 'document.edit.checklist.deactivate' | translate }}
                            } @else {
                                {{ 'document.edit.checklist.activate' | translate }}
                            }
                        </span>
                    </button>

                    @if (!isTemplateMode) {
                        <!-- Equipe do documento (qualquer tipo de documento; aberto a todos) -->
                        <button
                            type="button"
                            class="more-menu-item"
                            (click)="showMoreMenu.set(false); showResponsiblesModal.set(true)">
                            <ra-icon icon="profile-2user" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.responsibles' | translate }}</span>
                        </button>

                        <span class="more-menu-divider"></span>

                        <!-- Salvar como template -->
                        <button
                            type="button"
                            class="more-menu-item"
                            [disabled]="isDisabled"
                            (click)="showMoreMenu.set(false); isCreatingTemplate.set(true)">
                            <ra-icon icon="template" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.saveAsTemplate' | translate }}</span>
                        </button>
                    }

                    <!-- Histórico de alterações (timeline) — read-only, disponível sempre -->
                    <button
                        type="button"
                        class="more-menu-item"
                        (click)="showMoreMenu.set(false); showHistoryDrawer.set(true)">
                        <ra-icon icon="watch" varColor="currentColor" [size]="18" />
                        <span class="ra-label-s">{{ 'document.edit.header.history' | translate }}</span>
                    </button>

                    <!-- Lixeira (cesto de itens apagados) -->
                    <button
                        type="button"
                        class="more-menu-item"
                        [disabled]="isDisabled"
                        (click)="showMoreMenu.set(false); openTrash()">
                        <ra-icon icon="trash" varColor="currentColor" [size]="18" />
                        <span class="ra-label-s">{{ 'document.edit.header.trashTooltip' | translate }}</span>
                    </button>

                    @if (!isTemplateMode) {
                        <span class="more-menu-divider"></span>

                        <!-- Gerar PDF: imprime a prévia (o painel imprime, mesmo fechado). -->
                        <button
                            type="button"
                            class="more-menu-item"
                            [disabled]="isDisabled"
                            (click)="showMoreMenu.set(false); generatePdf()">
                            <ra-icon icon="document-download" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.generatePdf' | translate }}</span>
                        </button>

                        <!-- Baixar PDF: só para documentos com arquivo antigo ainda guardado
                             no servidor. Não se gera mais nenhum; ver `pdfCompleted`. -->
                        @if (pdfCompleted()) {
                            <button
                                type="button"
                                class="more-menu-item"
                                [disabled]="downloading()"
                                (click)="showMoreMenu.set(false); downloadPDF()">
                                <ra-icon icon="document-download" varColor="currentColor" [size]="18" />
                                <span class="ra-label-s">{{ 'document.edit.header.downloadPdf' | translate }}</span>
                            </button>
                        }

                        <!-- Compartilhar link: copia a URL pública e abre o preview em outra
                             aba (o que o botão "Visualizar" do header fazia). Fica colado no
                             QR Code, que codifica exatamente esta mesma URL. -->
                        <button
                            type="button"
                            class="more-menu-item"
                            [disabled]="editService.loading()"
                            (click)="showMoreMenu.set(false); editService.shareLink()">
                            <ra-icon icon="share" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.shareLink' | translate }}</span>
                        </button>

                        <!-- QR Code do documento (link do preview para imprimir/colar) -->
                        <button
                            type="button"
                            class="more-menu-item"
                            (click)="showMoreMenu.set(false); showModalDocumentQrcode.set(true)">
                            <ra-icon icon="scan-barcode" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.qrCode' | translate }}</span>
                        </button>

                        <!-- Visibilidade (público/privado + quem pode acessar) — NORMAL/QUOTE/CONTRACT -->
                        @if (
                            editDataService.document()?.type === DocumentTypeEnum.NORMAL ||
                            editDataService.document()?.type === DocumentTypeEnum.QUOTE ||
                            editDataService.document()?.type === DocumentTypeEnum.CONTRACT
                        ) {
                            <button
                                type="button"
                                class="more-menu-item"
                                (click)="showMoreMenu.set(false); showModalDocumentVisibility.set(true)">
                                <ra-icon icon="lock" varColor="currentColor" [size]="18" />
                                <span class="ra-label-s">{{ 'document.edit.header.visibility' | translate }}</span>
                            </button>
                        }

                        <!-- Duplicar documento (mesmo order) -->
                        <button
                            type="button"
                            class="more-menu-item"
                            [disabled]="isDisabled"
                            (click)="showMoreMenu.set(false); editService.cloneDocument()">
                            <ra-icon icon="copy" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.duplicateDocument' | translate }}</span>
                        </button>

                        <!-- Mover documento (outro order da mesma empresa) -->
                        <button
                            type="button"
                            class="more-menu-item"
                            [disabled]="isDisabled"
                            (click)="showMoreMenu.set(false); showModalMoveDocument.set(true)">
                            <ra-icon icon="arrow-swap-horizontal" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.moveDocument' | translate }}</span>
                        </button>

                        <span class="more-menu-divider"></span>

                        <!-- Excluir documento (destrutivo) -->
                        <button
                            type="button"
                            class="more-menu-item danger"
                            (click)="showMoreMenu.set(false); editService.removeDocument()">
                            <ra-icon icon="trash" varColor="currentColor" [size]="18" />
                            <span class="ra-label-s">{{ 'document.edit.header.deleteDocument' | translate }}</span>
                        </button>
                    }
                </div>
            }
        </div>
    </div>
</div>

<!-- Modal para criar template -->
@if (isCreatingTemplate()) {
    <modal-create-template 
        [documentId]="editDataService.document()?._id"
        (close)="isCreatingTemplate.set(false)" 
    />
}

<!-- Modal de listagem de itens da lixeira -->
@if (showModalListTrash()) 
{
    <modal-list-trash 
        [documentId]="editDataService.document()?._id" 
        (close)="showModalListTrash.set(false)" 
    />
}

<!-- Modal de configuração do documento -->
@if (isModalDocumentConfigVisible()) {
    <modal-document-config
        [config]="documentConfigForModal()"
        [loading]="loadingDocumentConfig()"
        [hasChanges]="configHasChanges()"
        [savingScope]="savingConfigScope()"
        [isQuote]="editDataService.document()?.type === DocumentTypeEnum.QUOTE"
        [openingEditor]="openingEditor()"
        [pushed]="showFooterEditor() || showHeaderEditor() || showCoverEditor() || isModalConfigScopeVisible()"
        (close)="onConfigClosed()"
        (save)="onSaveDocumentConfig($event)"
        (saveScope)="onSaveConfigScope()"
        (gridChanged)="onApplyGridToAllGroups($event)"
        (editFooter)="onEditFooter()"
        (editHeader)="onEditHeader()"
        (editCover)="onEditCover()"
    />
}

<!-- Modal do alcance: onde as alterações de configuração devem valer. -->
@if (isModalConfigScopeVisible()) {
    <modal-config-scope
        [hasOrder]="!!editDataService.document()?.orderId"
        [loading]="savingConfigScope()"
        (close)="isModalConfigScopeVisible.set(false)"
        (scopeSelected)="onConfigScopeSelected($event)"
    />
}

<!-- Modal de visibilidade (público/privado) — só NORMAL/QUOTE.
     Abrir "Quem pode acessar" troca de modal (sai a visibilidade, entra o acesso). -->
@if (showModalDocumentVisibility()) {
    <modal-document-visibility
        [isPrivate]="editDataService.document()?.private ?? false"
        [canToggle]="editDataService.document()?.type !== DocumentTypeEnum.CONTRACT"
        [loading]="loadingVisibility()"
        (close)="showModalDocumentVisibility.set(false)"
        (visibilityChange)="onVisibilityChange($event)"
        (openAccessList)="openAccessList()"
    />
}

<!-- Modal do QR Code do documento (imprimir / salvar PNG do link do preview) -->
@if (showModalDocumentQrcode()) {
    <modal-document-qrcode
        [documentId]="editDataService.document()?._id"
        [documentTitle]="editDataService.document()?.title ?? ''"
        [isPrivate]="editDataService.document()?.private ?? false"
        (close)="showModalDocumentQrcode.set(false)"
    />
}

<!-- Modal "Quem pode acessar". Fechar/salvar volta para a visibilidade. -->
@if (showModalDocumentAccess()) {
    <modal-document-access
        [sharedWith]="editDataService.document()?.sharedWith || []"
        [loading]="loadingDocumentAccess()"
        (close)="closeAccessList()"
        (save)="onSaveDocumentAccess($event)"
    />
}

<!-- Editor de conteúdo do rodapé (footer) -->
@if (showFooterEditor()) {
    <modal-footer-editor
        [footer]="editDataService.document()?.footer ?? []"
        [loading]="loadingFooter()"
        (close)="onFooterClosed()"
        (save)="onSaveFooter($event)"
    />
}

<!-- Editor de conteúdo do cabeçalho (header) -->
@if (showHeaderEditor()) {
    <modal-header-editor
        [header]="editDataService.document()?.header ?? []"
        [loading]="loadingHeader()"
        (close)="onHeaderClosed()"
        (save)="onSaveHeader($event)"
    />
}

<!-- Editor de conteúdo da capa (cover) -->
@if (showCoverEditor()) {
    <modal-cover-editor
        [loading]="loadingCover()"
        (close)="onCoverClosed()"
        (save)="onSaveCover($event)"
    />
}

<!-- Modal de signatários do contrato -->
@if (showModalContractSigners()) {
    <modal-contract-signers
        [signers]="editDataService.document()?.signedBy || []"
        [loading]="loadingContractSigners()"
        (close)="showModalContractSigners.set(false)"
    />
}

<!-- Modal de responsáveis (qualquer tipo de documento) -->
@if (showResponsiblesModal()) {
    <modal-responsibles (close)="showResponsiblesModal.set(false)" />
}

<!-- Modal de seleção do order de destino ("Mover documento") -->
@if (showModalMoveDocument()) {
    <ra-modal-list-orders
        [excludeOrderId]="editDataService.document()?.orderId"
        (close)="showModalMoveDocument.set(false)"
        (selectOrder)="onMoveDocument($event)"
    />
}

<!-- Drawer: histórico de alterações do documento (timeline) -->
@if (showHistoryDrawer()) {
    <document-history-panel (close)="showHistoryDrawer.set(false)" />
}

<!-- Barra de formatação: segunda linha do cabeçalho. Age no campo ativo da folha e abre o
     menu de campos (ver docs/PLANO-EDICAO-INLINE.md). -->
@if (!editModeService.isAiMode()) {
    <edit-toolbar />
}
